export const MANAGE_REWARD_ENDPOINTS = {
	BADGES: 'badges',
	ICONS: 'icons',
	BADGE: 'badge',
	BADGE_TYPE: 'badge-types',
};

export const AUTOMATED_REWARDS = [
	{ value: '1 year Work Milestone', label: '1 year Work Milestone' },
	{ value: '2 year Work Milestone', label: '2 year Work Milestone' },
	{ value: '3 year Work Milestone', label: '3 year Work Milestone' },
	{ value: '5 year Work Milestone', label: '5 year Work Milestone' },
	{ value: '10 year Work Milestone', label: '10 year Work Milestone' },
	{ value: '1st referral', label: '1st referral' },
	{ value: '5 referrals in a month', label: '5 referrals in a month' },
];

export const BADGE_VISIBILITY = [
	{ value: true, label: 'Active' },
	{ value: false, label: 'Inactive' },
];

export const BADGE_APPROVAL = [
	{ value: false, label: 'Yes' },
	{ value: true, label: 'No' },
];
export const BADGE_TYPE = {
	PEERTOPEER: 'On-the-Spot',
	NOMINATED: 'Nominated',
	AUTOMATED: 'Anniversary',
}

export const MAPPED_BADGE_TYPE_1 = {
	PEERTOPEER: '75b30c17-5617-4103-b781-d62b1d8a3fa7',
	NOMINATED: '2d05cd35-12dd-4c6e-b099-5221e026d680',
	AUTOMATED: '449e1150-ddac-485d-8321-537705c5bb40',
}

export const REVERSE_MAPING_BADGE_TYPE = {
	'75b30c17-5617-4103-b781-d62b1d8a3fa7': "PEERTOPEER",
	'2d05cd35-12dd-4c6e-b099-5221e026d680': "NOMINATED",
	'449e1150-ddac-485d-8321-537705c5bb40': "AUTOMATED",
}

export const REVERSE_MAPING_BADGE_ICON = {
	'd2b33bdd-f090-42ad-bb2a-432f6bcc615b': 'WRENCH',
	'741c3ac4-c5a5-41ec-b9fb-b0c42a0f3b73': 'TROPHY',
	'6711677e-832c-444e-868d-7f0b62274e61': 'USERS',
	'a68a23d6-4543-443c-b6fe-f12ac810cedf': 'STAR',
	'89882e76-ea17-4ceb-b169-b0bc56c249c8': 'ROCKET',
	'a6a56a9b-54ea-4971-a5be-26f442f8c5ca': 'WAND',
	'3b2a3eb3-7a1b-4b3f-b585-08a84d3364c7': 'THUMBSUP',
	'663f098c-f49c-4384-ad6f-f59f15abc026': 'HANDSHAKE',
	'250af36e-c073-4140-9967-659558e96fdd': 'HANDPLUS',
	'7b3eea86-a180-4846-ad04-25e5088c7847': 'PUZZLE',
	'c5cd07ae-d6b1-4ec4-8ae1-d0faa9595221': 'PIPERHAT',
	'abf3ede4-f9a5-40f5-b3ff-e26624dc2d1f': 'PEOPLEPULLING',
	'b7f38f46-d835-4a7a-bf41-d75ab1d1e19b': 'PEOPLECARRYING',
	'bafa0cfb-2ddd-43ca-b954-4814c09b85a1': 'MUG',
	'f45916fc-b22a-4304-8b01-687adfd0ce96': 'MEDAL',
	'01f7790e-e7da-4ea3-806f-f9459bf2565b': 'LIGHTBULB',
	'7252331b-e81f-4c41-a57b-fd762bc617b9': 'HEART',
	'962a7220-5c4d-4730-bea0-e56e9f9fb9ac': 'AWARD',
	'f734ab47-7f05-43c1-ae4b-92a806b91726': 'HANDHEART',
	'4a20bb22-3faa-4fcc-9e8b-e507c22ae904': 'GIFT',
	'7c1dbb3f-67e6-45df-8924-54af00fa1933': 'FIRE',
	'a75409c4-fe4c-417a-b506-77f67313d891': 'DUMBELL',
	'f12b7223-b2f3-4351-95d8-c7f218e71657': 'CROWN',
	'fcdb094a-a59c-41d4-a540-293c80f1ccd1': 'BRUSH',
	'c98f6802-c79b-4d32-a13b-b65fc19d7258': 'BOLT',
	'c4794131-7cb5-46ac-87cb-b6b7be3eb3a5': 'BOLT',
	'cc4c300f-99ca-4f91-ac4f-14c12511a2c3': 'COMMENTS',
}

export const ICON_COMPLETE_MAP = [
  {
    "id": "c5f2c137-2ae3-4048-96f8-349db4b1a96e",
    "icon": "IconHat_wizardc5f2c137-2ae3-4048-96f8-349db4b1a96e",
    "code": "HAT_WIZARD",
    "name": "Wizard Hat"
  },
  {
    "id": "91d67871-c256-455b-b636-e7e1e5a86cb7",
    "icon": "IconSeedling91d67871-c256-455b-b636-e7e1e5a86cb7",
    "code": "SEEDLING",
    "name": "Seedling"
  },
  {
    "id": "1035437b-17fd-40db-8a3a-3a5863595760",
    "icon": "IconBrain1035437b-17fd-40db-8a3a-3a5863595760",
    "code": "BRAIN",
    "name": "Brain"
  },
  {
    "id": "bda0ad3e-d5e4-45a2-99b6-74d8fcc88055",
    "icon": "IconChampagne_glassesbda0ad3e-d5e4-45a2-99b6-74d8fcc88055",
    "code": "CHAMPAGNE_GLASSES",
    "name": "Champagne"
  },
  {
    "id": "92e8ffb4-d90e-45c6-8ccd-ecaef3bd5141",
    "icon": "IconShield_halved92e8ffb4-d90e-45c6-8ccd-ecaef3bd5141",
    "code": "SHIELD_HALVED",
    "name": "Shield"
  },
  {
    "id": "13a388b1-135f-4aa1-b745-348153320c75",
    "icon": "IconHouse13a388b1-135f-4aa1-b745-348153320c75",
    "code": "HOUSE",
    "name": "House"
  },
  {
    "id": "fea35862-0de0-4b89-982b-aea086f7a963",
    "icon": "IconBookfea35862-0de0-4b89-982b-aea086f7a963",
    "code": "BOOK",
    "name": "Book"
  },
  {
    "id": "91fa7de4-a0b6-44a8-a53b-19654225c8b1",
    "icon": "IconBullseye91fa7de4-a0b6-44a8-a53b-19654225c8b1",
    "code": "BULLSEYE",
    "name": "Bullseye"
  },
  {
    "id": "cc92b7b0-5556-40b2-bbcb-b6b953095419",
    "icon": "IconKeycc92b7b0-5556-40b2-bbcb-b6b953095419",
    "code": "KEY",
    "name": "Key"
  },
  {
    "id": "5289e694-a296-415e-ae30-baa4876a8378",
    "icon": "IconScrewdriver_wrench5289e694-a296-415e-ae30-baa4876a8378",
    "code": "SCREWDRIVER_WRENCH",
    "name": "Tools"
  },
  {
    "id": "1ae03357-3e02-4fc5-aa67-84c8a2ef9fdf",
    "icon": "IconThumbtack1ae03357-3e02-4fc5-aa67-84c8a2ef9fdf",
    "code": "THUMBTACK",
    "name": "Thumbtack"
  },
  {
    "id": "36e27cc0-98ad-4b3f-a73c-827811ab7860",
    "icon": "IconSuitcase_medical36e27cc0-98ad-4b3f-a73c-827811ab7860",
    "code": "SUITCASE_MEDICAL",
    "name": "Medical Suitcase"
  },
  {
    "id": "2767209a-8553-454e-a8eb-788f522a2ab2",
    "icon": "IconBullhorn2767209a-8553-454e-a8eb-788f522a2ab2",
    "code": "BULLHORN",
    "name": "Bullhorn"
  },
  {
    "id": "6dcaf639-b7d6-48fb-a41e-167ffd7c0156",
    "icon": "IconFlag_checkered6dcaf639-b7d6-48fb-a41e-167ffd7c0156",
    "code": "FLAG_CHECKERED",
    "name": "Checkered Flag"
  },
  {
    "id": "8350bdee-5534-406d-96ca-c070a8cc8827",
    "icon": "IconGears8350bdee-5534-406d-96ca-c070a8cc8827",
    "code": "GEARS",
    "name": "Gears"
  },
  {
    "id": "20645554-9a30-43a7-aabc-1145289a26fd",
    "icon": "IconGem20645554-9a30-43a7-aabc-1145289a26fd",
    "code": "GEM",
    "name": "Gem"
  },
  {
    "id": "a4110de3-da50-4d06-81a8-bf119227e53e",
    "icon": "IconChalkboard_usera4110de3-da50-4d06-81a8-bf119227e53e",
    "code": "CHALKBOARD_USER",
    "name": "Chalkboard"
  },
  {
    "id": "3c6c18b2-1b4d-4f19-b9ec-a74c1c48f3fa",
    "icon": "IconNetwork_wired3c6c18b2-1b4d-4f19-b9ec-a74c1c48f3fa",
    "code": "NETWORK_WIRED",
    "name": "Network"
  },
  {
    "id": "57d2df60-9302-4d9b-9e10-61507d120e5b",
    "icon": "IconStopwatch57d2df60-9302-4d9b-9e10-61507d120e5b",
    "code": "STOPWATCH",
    "name": "Stopwatch"
  },
  {
    "id": "f8dbeab2-4c14-489d-a0da-c78f4eeb412c",
    "icon": "IconList_checkf8dbeab2-4c14-489d-a0da-c78f4eeb412c",
    "code": "LIST_CHECK",
    "name": "List Check"
  },
  {
    "id": "6f010f83-6319-47a4-9d76-edad1bf1a3eb",
    "icon": "IconFlask6f010f83-6319-47a4-9d76-edad1bf1a3eb",
    "code": "FLASK",
    "name": "Flask"
  },
  {
    "id": "54f33d37-ba1d-45a9-adbb-5df5ed907f9d",
    "icon": "IconSun54f33d37-ba1d-45a9-adbb-5df5ed907f9d",
    "code": "SUN",
    "name": "Sun"
  },
  {
    "id": "44916175-23cc-46de-98c6-0902327e81b9",
    "icon": "IconBook_open_reader44916175-23cc-46de-98c6-0902327e81b9",
    "code": "BOOK_OPEN_READER",
    "name": "Open Book"
  },
  {
    "id": "7a8d6af9-f510-4d08-b424-4a322f874539",
    "icon": "IconAnchor7a8d6af9-f510-4d08-b424-4a322f874539",
    "code": "ANCHOR",
    "name": "Anchor"
  },
  {
    "id": "c54d06a4-06e6-4d75-8a4a-af51626a1299",
    "icon": "IconFace_smilec54d06a4-06e6-4d75-8a4a-af51626a1299",
    "code": "FACE_SMILE",
    "name": "Face Smile"
  },
  {
    "id": "80c71964-8d6d-42b1-aa4c-19efee4e7432",
    "icon": "IconMountain80c71964-8d6d-42b1-aa4c-19efee4e7432",
    "code": "MOUNTAIN",
    "name": "Mountain"
  },
  {
    "id": "c8010b5e-2588-40db-ad73-1a9e6f8e1f40",
    "icon": "IconGraduation_capc8010b5e-2588-40db-ad73-1a9e6f8e1f40",
    "code": "GRADUATION_CAP",
    "name": "Graduation Cap"
  },
  {
    "id": "38d24467-7f0e-4418-95cc-cd3486639a5e",
    "icon": "IconMagnifying_glass38d24467-7f0e-4418-95cc-cd3486639a5e",
    "code": "MAGNIFYING_GLASS",
    "name": "Magnifying Glass"
  },
  {
    "id": "df097730-7d14-4db4-a62d-6ad5b9d63425",
    "icon": "IconChart_linedf097730-7d14-4db4-a62d-6ad5b9d63425",
    "code": "CHART_LINE",
    "name": "Chart"
  },
  {
    "id": "b09fd806-a949-4b46-a586-18d5cee6a227",
    "icon": "IconBinocularsb09fd806-a949-4b46-a586-18d5cee6a227",
    "code": "BINOCULARS",
    "name": "Binoculars"
  },
  {
    "id": "1b35eff8-34ad-45c7-ba94-166f5966acb8",
    "icon": "IconPen1b35eff8-34ad-45c7-ba94-166f5966acb8",
    "code": "PEN",
    "name": "Pen"
  },
  {
    "id": "69c1e5bc-3212-421a-b81d-1256a710983c",
    "icon": "IconTicket69c1e5bc-3212-421a-b81d-1256a710983c",
    "code": "TICKET",
    "name": "Ticket"
  },
  {
    "id": "3242992f-f8fc-4d4c-9b23-4d1a5ec6da5b",
    "icon": "IconRibbon3242992f-f8fc-4d4c-9b23-4d1a5ec6da5b",
    "code": "RIBBON",
    "name": "Ribbon"
  },
  {
    "id": "bea87261-70a6-47da-b4da-3dc5042cf478",
    "icon": "IconCertificatebea87261-70a6-47da-b4da-3dc5042cf478",
    "code": "CERTIFICATE",
    "name": "Certificate"
  },
  {
    "id": "abf3ede4-f9a5-40f5-b3ff-e26624dc2d1f",
    "icon": "IconPeoplepulling-1feffd39-4f49-42f8-981a-6f905e44406b",
    "code": "PEOPLEPULLING",
    "name": "People Pulling"
  },
  {
    "id": "250af36e-c073-4140-9967-659558e96fdd",
    "icon": "IconHandplus-6649aa94-3b83-43c0-af77-d68720729ad4",
    "code": "HANDPLUS",
    "name": "Hand Plus"
  },
  {
    "id": "663f098c-f49c-4384-ad6f-f59f15abc026",
    "icon": "IconHandshake-09f5481a-dcb8-42c6-a2b1-5a6fab8104cf",
    "code": "HANDSHAKE",
    "name": "Handshake"
  },
  {
    "id": "01f7790e-e7da-4ea3-806f-f9459bf2565b",
    "icon": "IconLightbulb-0e61e1fa-a40a-4e8d-ba49-6ae484fa6d83",
    "code": "LIGHTBULB",
    "name": "Lightbulb"
  },
  {
    "id": "09c73d48-ddef-4f5e-b2c2-29ecc8887c4d",
    "icon": "IconCake_candles09c73d48-ddef-4f5e-b2c2-29ecc8887c4d",
    "code": "CAKE_CANDLES",
    "name": "Cake"
  },
  {
    "id": "3b2a3eb3-7a1b-4b3f-b585-08a84d3364c7",
    "icon": "IconThumbsup-f74394ab-8920-460d-9242-40c2d1493d71",
    "code": "THUMBSUP",
    "name": "Thumbs Up"
  },
  {
    "id": "4a20bb22-3faa-4fcc-9e8b-e507c22ae904",
    "icon": "IconGift-7ac3553b-6469-4fdb-b1aa-2599c7583dcb",
    "code": "GIFT",
    "name": "Gift"
  },
  {
    "id": "962a7220-5c4d-4730-bea0-e56e9f9fb9ac",
    "icon": "IconAward-1702c9f5-6ea3-4501-9e29-2d1e7af2d360",
    "code": "AWARD",
    "name": "Award"
  },
  {
    "id": "a68a23d6-4543-443c-b6fe-f12ac810cedf",
    "icon": "IconStar-2ee93de6-83ec-4ce8-a662-88c5af2b1ffd",
    "code": "STAR",
    "name": "Star"
  },
  {
    "id": "a6a56a9b-54ea-4971-a5be-26f442f8c5ca",
    "icon": "IconWand-2eec9bf8-6009-479f-aa01-7767d9dcab38",
    "code": "WAND",
    "name": "Wand"
  },
  {
    "id": "8d5800dd-97c6-4117-868a-950d4097cc48",
    "icon": "IconCalendar-c05bda57-3b17-4732-97d0-029eb21f793b",
    "code": "CALENDAR",
    "name": "Calendar"
  },
  {
    "id": "6711677e-832c-444e-868d-7f0b62274e61",
    "icon": "IconUsers-c37473ab-f92d-4dc6-96bd-ca90dbb67bd1",
    "code": "USERS",
    "name": "Users"
  },
  {
    "id": "7252331b-e81f-4c41-a57b-fd762bc617b9",
    "icon": "IconHeart-ddbfbe13-079c-47f0-a164-c9f02d4f8c38",
    "code": "HEART",
    "name": "Heart"
  },
  {
    "id": "741c3ac4-c5a5-41ec-b9fb-b0c42a0f3b73",
    "icon": "IconTrophy-37fe1f32-226a-430a-b322-3a146e27ff92",
    "code": "TROPHY",
    "name": "Trophy"
  },
  {
    "id": "7b3eea86-a180-4846-ad04-25e5088c7847",
    "icon": "IconPuzzle-65d5dbc0-f704-49df-bce5-ff1cfaaa38ae",
    "code": "PUZZLE",
    "name": "Puzzle"
  },
  {
    "id": "7c1dbb3f-67e6-45df-8924-54af00fa1933",
    "icon": "IconFire-f138cf03-2b67-417c-a8d4-51029edf6ff6",
    "code": "FIRE",
    "name": "Fire"
  },
  {
    "id": "89882e76-ea17-4ceb-b169-b0bc56c249c8",
    "icon": "IconRocket-844149bc-807c-43ab-9b1d-55e5a07708b7",
    "code": "ROCKET",
    "name": "Rocket"
  },
  {
    "id": "a75409c4-fe4c-417a-b506-77f67313d891",
    "icon": "IconDumbell-de19568e-f02e-4bb2-b7c2-6883e99d7a6f",
    "code": "DUMBELL",
    "name": "Dumbell"
  },
  {
    "id": "bafa0cfb-2ddd-43ca-b954-4814c09b85a1",
    "icon": "IconMug-83ffded7-4c22-4cc2-a8fa-c4d3a14248c7",
    "code": "MUG",
    "name": "Mug"
  },
  {
    "id": "c4794131-7cb5-46ac-87cb-b6b7be3eb3a5",
    "icon": "IconBell-501c8d14-9c3a-412c-a7ac-f6f0e2959d90",
    "code": "BELL",
    "name": "Bell"
  },
  {
    "id": "c98f6802-c79b-4d32-a13b-b65fc19d7258",
    "icon": "IconBolt-fdc3dd21-bb02-4dbc-94e9-c30a82787cb9",
    "code": "BOLT",
    "name": "Bolt"
  },
  {
    "id": "cc4c300f-99ca-4f91-ac4f-14c12511a2c3",
    "icon": "IconComments-42f6f4e3-3136-4b46-90d8-2e39bdf3d112",
    "code": "COMMENTS",
    "name": "Comments"
  },
  {
    "id": "d2b33bdd-f090-42ad-bb2a-432f6bcc615b",
    "icon": "IconWrench-e3f3556c-3d09-4d8a-8b68-bd730420c2c9",
    "code": "WRENCH",
    "name": "Wrench"
  },
  {
    "id": "f12b7223-b2f3-4351-95d8-c7f218e71657",
    "icon": "IconCrown-f7f0d9f0-7c2a-4d17-a665-9a52e0f70656",
    "code": "CROWN",
    "name": "Crown"
  },
  {
    "id": "f45916fc-b22a-4304-8b01-687adfd0ce96",
    "icon": "IconMedal-eec4ed28-c939-4791-b596-9fb65ca235e4",
    "code": "MEDAL",
    "name": "Medal"
  },
  {
    "id": "fcdb094a-a59c-41d4-a540-293c80f1ccd1",
    "icon": "IconBrush-4b6e000d-5287-4ff1-9cfb-811a8d5dbf3b",
    "code": "BRUSH",
    "name": "Brush"
  },
  {
    "id": "e075b713-7e1d-4b54-92f6-84622c440404",
    "icon": "IconSend-b0733816-f6f6-4fa9-9e83-cf3392816a36",
    "code": "SEND2",
    "name": "Cat"
  },
  {
    "id": "f734ab47-7f05-43c1-ae4b-92a806b91726",
    "icon": "IconHandheart-ad59e309-a55c-47c5-9fb8-cbdd44a7ab0b",
    "code": "HANDHEART",
    "name": "Holding Heart"
  },
  {
    "id": "b7f38f46-d835-4a7a-bf41-d75ab1d1e19b",
    "icon": "IconPeoplecarrying-eb987e63-6fb1-4fd5-9ad9-8a929242229a",
    "code": "PEOPLECARRYING",
    "name": "People Carry"
  },
  {
    "id": "c5cd07ae-d6b1-4ec4-8ae1-d0faa9595221",
    "icon": "IconPiperhat-475b2e3c-8374-4082-a10e-d6ace51d9e40",
    "code": "PIPERHAT",
    "name": "Piper Hat"
  }
];

export const MAPPED_BADGE_ICON_1 = {
	WRENCH: 'd2b33bdd-f090-42ad-bb2a-432f6bcc615b',
	TROPHY: '741c3ac4-c5a5-41ec-b9fb-b0c42a0f3b73',
	USERS: '6711677e-832c-444e-868d-7f0b62274e61',
	STAR: 'a68a23d6-4543-443c-b6fe-f12ac810cedf',
	ROCKET: '89882e76-ea17-4ceb-b169-b0bc56c249c8',
	WAND: 'a6a56a9b-54ea-4971-a5be-26f442f8c5ca',
	THUMBS_UP: '3b2a3eb3-7a1b-4b3f-b585-08a84d3364c7',
	HANDSHAKE: '663f098c-f49c-4384-ad6f-f59f15abc026',
	HAND_PLUS: '250af36e-c073-4140-9967-659558e96fdd',
	PUZZLE: '7b3eea86-a180-4846-ad04-25e5088c7847',
	PIPER_HAT: 'c5cd07ae-d6b1-4ec4-8ae1-d0faa9595221',
	PEOPLE_PULLING: 'abf3ede4-f9a5-40f5-b3ff-e26624dc2d1f',
	PEOPLE_CARRYING: 'b7f38f46-d835-4a7a-bf41-d75ab1d1e19b',
	MUG: 'bafa0cfb-2ddd-43ca-b954-4814c09b85a1',
	MEDAL: 'f45916fc-b22a-4304-8b01-687adfd0ce96',
	LIGHT_BULB: '01f7790e-e7da-4ea3-806f-f9459bf2565b',
	HEART: '7252331b-e81f-4c41-a57b-fd762bc617b9',
	AWARD: '962a7220-5c4d-4730-bea0-e56e9f9fb9ac',
	HAND_HEART: 'f734ab47-7f05-43c1-ae4b-92a806b91726',
	GIFT: '4a20bb22-3faa-4fcc-9e8b-e507c22ae904',
	FIRE: '7c1dbb3f-67e6-45df-8924-54af00fa1933',
	DUMBELL: 'a75409c4-fe4c-417a-b506-77f67313d891',
	CROWN: 'f12b7223-b2f3-4351-95d8-c7f218e71657',
	BRUSH: 'fcdb094a-a59c-41d4-a540-293c80f1ccd1',
	BOLT: 'c98f6802-c79b-4d32-a13b-b65fc19d7258',
	BELL: 'c4794131-7cb5-46ac-87cb-b6b7be3eb3a5',
	COMMENTS: 'cc4c300f-99ca-4f91-ac4f-14c12511a2c3',
}

export const MAPPED_BADGE_TYPE = {
	PEERTOPEER: 'PEERTOPEER',
	NOMINATED: 'NOMINATED',
	AUTOMATED: 'AUTOMATED',
}

export const REVERSE_MAPPED_BADGE_TYPE = {
	"On-the-Spot": 'PEERTOPEER',
	"Nominated": 'NOMINATED',
	"Anniversary": 'AUTOMATED'
}

export const MAPPED_BADGE_ICON = {
	WRENCH: 'WRENCH',
	TROPHY: 'TROPHY',
	USERS: 'USERS',
	STAR: 'STAR',
	ROCKET: 'ROCKET',
	WAND: 'WAND',
	THUMBS_UP: 'THUMBSUP',
	HANDSHAKE: 'HANDSHAKE',
	HAND_PLUS: 'HANDPLUS',
	PUZZLE: 'PUZZLE',
	PIPER_HAT: 'PIPERHAT',
	PEOPLE_PULLING: 'PEOPLEPULLING',
	PEOPLE_CARRYING: 'PEOPLECARRYING',
	MUG: 'MUG',
	MEDAL: 'MEDAL',
	LIGHT_BULB: 'LIGHTBULB',
	HEART: 'HEART',
	AWARD: 'AWARD',
	HAND_HEART: 'HANDHEART',
	GIFT: 'GIFT',
	FIRE: 'FIRE',
	DUMBELL: 'DUMBELL',
	CROWN: 'CROWN',
	BRUSH: 'BRUSH',
	BOLT: 'BOLT',
	BELL: 'BELL',
	COMMENTS: 'COMMENTS',
	ANCHOR: 'ANCHOR',
	BINOCULARS: 'BINOCULARS',
	BOOK_OPEN_READER: 'BOOK_OPEN_READER',
	BOOK: 'BOOK',
	BRAIN: 'BRAIN',
	BULLHORN: 'BULLHORN',
	BULLSEYE: 'BULLSEYE',
	CAKE_CANDLES: 'CAKE_CANDLES',
  CALENDAR: 'CALENDAR',
	CERTIFICATE: 'CERTIFICATE',
	CHALKBOARD_USER: 'CHALKBOARD_USER',
	CHAMPAGNE_GLASSES: 'CHAMPAGNE_GLASSES',
	CHART_LINE: 'CHART_LINE',
	FACE_SMILE: 'FACE_SMILE',
	FLAG_CHECKERED: 'FLAG_CHECKERED',
	FLASK: 'FLASK',
	GEARS: 'GEARS',
	GEM: 'GEM',
	GRADUATION_CAP: 'GRADUATION_CAP',
	HAT_WIZARD: 'HAT_WIZARD',
	HOUSE: 'HOUSE',
	KEY: 'KEY',
	LIST_CHECK: 'LIST_CHECK',
	MAGNIFYING_GLASS: 'MAGNIFYING_GLASS',
	MOUNTAIN: 'MOUNTAIN',
	NETWORK_WIRED: 'NETWORK_WIRED',
	PEN: 'PEN',
	RIBBON: 'RIBBON',
	SCREWDRIVER_WRENCH: 'SCREWDRIVER_WRENCH',
	SEEDLING: 'SEEDLING',
	SHIELD_HALVED: 'SHIELD_HALVED',
	STOPWATCH: 'STOPWATCH',
	SUITCASE_MEDICAL: 'SUITCASE_MEDICAL',
	SUN: 'SUN',
	THUMBTACK: 'THUMBTACK',
	TICKET: 'TICKET',

}

export const SSO_Required_CONSTANTS = {
	STANDARD: "Standard",
	SSO: "SSO"
}